<template>
  <div class="col-3-center">
    <!-- <h2>Ende der Umfrage am 20.07.2019</h2> -->
    <p>Die Umfrage in der Etappe 2 ist nun beendet. Wir bedanken uns für Ihre zahlreiche Teilnahme.</p>
    <p>
      In den nachfolgenden Grafiken finden Sie Auszüge aus den Ergebnissen der Umfrage. Die ganze Präsentation können Sie
      <a
        href="/static/dokumente/umfrage_ergebnis.pdf"
        target="_blank"
      >hier</a> als PDF herunterladen.
    </p>
    <div>
      <Gallery :items="items" />
    </div>
    <!-- <Carousel :items="items" /> -->
    <!-- <div style="width: 100%; background: green">test</div> -->
    <!-- <img src="@/assets/grafiken/machmit/umfrage_ergebnis_1.png" />
        <img src="@/assets/grafiken/machmit/umfrage_ergebnis_2.png" />
        <img src="@/assets/grafiken/machmit/umfrage_ergebnis_3.png" />
    <img src="@/assets/grafiken/machmit/umfrage_ergebnis_4.png" />-->
    <!-- <hr /> -->
  </div>
</template>

<script>
import Anmeldung from "@/components/MachMit/Anmeldung.vue";
import Timeline from "@/components/Timeline.vue";
import Gallery from "@/components/Gallery.vue";
import Carousel from "@/components/Carousel.vue";
export default {
  components: {
    Anmeldung,
    Timeline,
    Gallery,
    Carousel
  },
  data() {
    return {
      items: [
        { src: require("@/assets/grafiken/machmit/umfrage_ergebnis_1.png") },
        { src: require("@/assets/grafiken/machmit/umfrage_ergebnis_2.png") },
        { src: require("@/assets/grafiken/machmit/umfrage_ergebnis_3.png") },
        { src: require("@/assets/grafiken/machmit/umfrage_ergebnis_4.png") }
      ]
    };
  },
  methods: {
    showForm() {}
  }
};
</script>
<style scoped lang="scss">
section {
  height: 100%;
}
img {
  width: 100%;
}
</style>
